import React, { Component } from "react";

class HowToUse extends Component {
  // const { state } = this.props.location;
  // window.location = state ? state.from.pathname : "/";

  render() {
    return (
      <div className="text-center">
        <h3 className="">Como Usar</h3>
        {/* <h5 className="text-secondary" style={{ marginTop: 100 }}> */}
        <h5 className="text-secondary mt-4">
          O UniNotas é uma plataforma que lhe permite avaliar a sua actual ou
          antiga universidade de forma anónima, compreendendo diversos aspectos
          que englobam desde a infra-estrutura até a qualidade de ensino;
          Apresenta às lideranças das universidades uma visão geral sobre a
          qualidade dos seus serviços de acordo às avaliações dos seus
          estudantes; Oferece também aos futuros estudantes uma melhor percepção
          sobre as diversas universidades disponiveis.
        </h5>
        {/* <h5 className="text-secondary mt-5">
          Após a realização do login, será direcionado para o seu perfil.
          Selecione a sua universidade  ou não (caso não
          seja um estudante universitário).
        </h5> */}
        <h4 className=" mt-5">Médias das Avaliações</h4>
        <h5 className="text-secondary">
          Clique sobre o ícone do UniNotas para ver a lista de universidades.
          Use a barra de procura para encontrar facilmente a sua universidade.
          Cada universidade vem acompanhada das médias das suas avaliações numa
          escala de 1 à 5, onde:
        </h5>
        <h5 className="text-secondary text-justify offset-md-5">
          1 = Muito mau <br />2 = Mau <br />3 = Mais ou menos <br />4 = Bom{" "}
          <br /> 5 = Muito bom
        </h5>
        {/* <br />2 = Mau <br />3 = Mais ou menos <br />4 = Bom <br /> 5 = Muito bom */}
        <h4 className=" mt-5">Avaliar</h4>
        <h5 className="text-secondary ">
          Clique sobre uma universidade para ver mais detalhes sobre a mesma, e
          poder avaliar, ver e/ou comentar em avaliações feitas por outros
          estudantes. Ao fazer a avaliação de uma universidade responderá
          perguntas relacionadas a diversas áreas. Dê informações reais, de
          acordo à sua experiência enquanto estudante.
        </h5>
        <h4 className=" mt-5">Reavaliar</h4>
        <h5 className="text-secondary">
          Pode refazer a sua avaliação de uma universidade. a sua avaliação
          prévia continuará visivel mas apenas a sua avaliação mais recente
          contará para a média da universidade. Isto permitirá que a
          universidade tenha uma média positiva após melhoria nos seus serviços.
        </h5>
        <h4 className="mt-5">Em caso de dúvida, contacte a nossa equipe</h4>
        <h5 className="text-secondary">Email: unninotas@gmail.com</h5>
        {this.props.location.state && this.props.location.state.newUser ? (
          <button
            className="btn btn-primary mt-4"
            onClick={(e) => {
              e.preventDefault();
              this.props.history.push({
                pathname: "/profile",
                state: { newUser: true },
              });
            }}
          >
            Continuar
          </button>
        ) : null}{" "}
      </div>
    );
  }
}

export default HowToUse;
